import { RootState } from '@/store/store'
import { createSelector } from '@reduxjs/toolkit'
import { AgentConversation } from '@/agent/conversations/store/slice'

/**
 * Selector: Conversation Selected Files Content Expanded
 * A selector that retrieves the expanded state of the selected files content for a given conversation.
 */
export const selectConversationSelectedFilesContentExpanded = (state: RootState, props: { chatId: string | undefined }) =>
  state.chatUxState.selectedFilesContentExpanded[props.chatId ?? ''] ?? false

/**
 * Selector: Active Conversation Id
 */
export const selectActiveConversationId = (state: RootState) => state.chatUxState.activeConversationId

/**
 * Selector: Active Conversation
 * Returns the currently active conversation, or null.
 */
export const selectActiveConversation = createSelector(
  (state: RootState) => state.chatUxState.activeConversationId,
  (state: RootState) => state.agentConversationsState.conversations,
  (activeId, conversations): AgentConversation | null => (activeId ? conversations[activeId] ?? null : null)
)

/**
 * Selector: Prompt Assist Enabled
 */
export const selectPromptAssistEnabled = (state: RootState) => state.chatUxState.promptAssistEnabled
export const selectPromptAssistLastFetched = (state: RootState) => state.chatUxState.promptAssistLastFetched
export const selectSettingsLoaded = (state: RootState) => state.chatUxState.promptAssistLastFetched !== null
export const selectPromptAssistFetchIsLoading = (state: RootState) => state.chatUxState.promptAssistFetchIsLoading
export const selectDefaultJurisdiction = (state: RootState) => state.chatUxState.defaultJurisdiction
